module.exports = __webpack_public_path__ + "img/trunk_8x4_z16.a2bede25.svg";